import { useState } from "react";

const Input = ({ label, type = 'text', isDark = false, value, onChange, ...props }) => {
    const [focused, setFocused] = useState(false);

    const isFilled = value && value.length > 0;
    const containerClass = `input-container${focused ? ' focused' : ''}${isFilled ? ' filled' : ''}${isDark ? ' dark' : ''}`;

    return (
        <div className={containerClass}>
            <label className="input-label">{label}</label>
            <input
                className="input-field"
                type={type}
                defaultValue={value}
                onChange={onChange}
                onFocus={() => setFocused(true)}
                onBlur={(e) => {
                    if (!e.target.value) setFocused(false);
                    else setFocused(false); // Keeps label up for filled input
                }}
                {...props}
            />
            <span className="input-underline" />
        </div>
    );
};

export default Input;